<template>
  <div v-loading.fullscreen.lock="showLoading" :element-loading-text="message" element-loading-spinner="el-icon-loading">
  </div>
</template>

<script>

import axios from "axios";
import { CA_API } from "@/utils/apilist";

import {
  CA_APP_ID,
  CA_APP_SECRET,
  CA_LOGIN_BASEURL,
} from "@/utils/ca/person/caConfig.js";

export default {
  name: "CALogin",
  data() {
    return {
      message: "登录验证中...",
      showLoading: false,
      code: null,
      token: "",
      // redirect_uri: "https://hklgbfwgl.com/calogin",
      redirect_uri: window.location.origin + "/calogin",
    };
  },
  created() {
    console.log("============进入路由================");
    console.log(this.redirect_uri);
    this.code = this.$route.query.code;
    this.showLoading = true;
    if (this.code) {
      console.log("==============code==================");
      console.log(this.code);
      this.getCaAccessToken();
    } else {
      this.redirectToCaLogin();
    }
  },
  methods: {

    //获取第三方CA授权
    getCaAccessToken() {
      this.showLoading = true;
      this.message = "授权认证中...";
      let url = CA_API.PERSON_AUTH_TOKEN + "?code=" + this.code;
      this.$axios.get(url).
        then(res => {

          console.log("=======获取令牌=======");
          console.log(res);
          if (res.data.code == 200) {
            let { access_token, token_type, id_token } = res.data.obj;
            this.token = access_token;
            this.getUserInfoByToken()
          } else {
            this.$message.error(res.data.message);
          }


        }).catch((err) => {
          this.$message.error("没有获取到token!");
        });

    },


    // 获取登录用户信息
    getUserInfoByToken() {
      this.showLoading = true;
      this.message = "获取用户信息...";

      let url = CA_API.PERSON_AUTH_INFO + "?token=" + this.token;
      this.$axios.get(url).
        then(res => {
          console.log("=======ca-获取用户信息=======");
          console.log(res);

          if (res.data.code == 200) {
            //个人信息
            const { account, certificate, id_no, id_type, mobile, name } = res.data.obj;
            //ca认证之后，系统内部登录流程JWT认证,
            this.systemLogin({ username: account, password: "" });
            //跳转首页
            //跳转首页
            this.message = "登录成功...";
          } else {
            this.$message.error(res.data.message);
          }

        }).catch((err) => {
          this.loading = false;
          this.$message.error("ca-获取用户信息异常!");
          //跳转回到页面，然后会调用redirectToThirdLogin 跳转到CA认证页
          // window.location.href = this.redirect_uri;
        });


    },



    // CA认证完成之后需要走系统本身的登录流程
    systemLogin(loginParam) {
      this.$axios
        .post("/calogin", loginParam)
        .then((response) => {
          //获取到用户信息和token
          const { data } = response;
          if (data.code != "200") {
            this.$message.error(data.message);
            return;
          }

          if (!data.obj) {
            this.$message.error("返回的数据格式不正确");
            return;
          }

          // 获取token并存储
          const { token, user } = data.obj;
          if (token) {
            this.loading = false;
            this.$store.commit("user/SET_TOKEN", token);
            this.$store.commit("user/SET_USERINFO", user);
            this.$store.commit("user/SET_MENUS", []);
            this.$router.push("/layout");
          } else {
            this.$message.error("未能正确返回token");
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },

    // 跳转到CA认证页，通过个人验证方式登录
    redirectToCaLogin() {
      this.showLoading = true;
      this.message = "跳转到认证页面...";
      let CALOGIN_URL =
        CA_LOGIN_BASEURL +
        "/authn/person/authorize?" +
        `response_type=code&scope=opendid&auth_type=authentication&client_id=${CA_APP_ID}&redirect_uri=${this.redirect_uri}`;
      window.location.href = CALOGIN_URL;
    }


  },
};
</script>
